import React from 'react';
import axios from 'axios';
import queryString from 'query-string';
import { useLocation, useHistory } from 'react-router-dom';
import jwtDecode from 'jwt-decode';

import { apiEndpoints } from 'helpers/endpoints';
import { trackError, errorMessage, saveTokens } from 'helpers';

import { Storage, getFlag, flags } from 'services';
import { useAuthDispatch } from 'context';

import styles from './CallbackScreen.module.scss';

interface AuthResponseData {
  org_uuid: string;
  user_uuid: string;
}

/**
 * Checks to see if we should redirect the user to onboarding.
 * If any of the following rule is true the user should be onboarded:
 * 1 - We are forcing onboarding through localStorage
 * 2 - User has not completed onboarding
 * 3 - User is a new user
 * @param userData
 */
const shouldOnboardUser = (isNewUser: boolean, lastOnboardingStep?: string) => {
  const forceOnboarding = getFlag(flags.ForceOnboarding);
  const hasCompletedOnboarding =
    lastOnboardingStep === null ||
    lastOnboardingStep === 'finished' ||
    lastOnboardingStep === 'finish';
  return forceOnboarding || isNewUser || !hasCompletedOnboarding;
};

export const CallbackScreen = () => {
  const dispatch = useAuthDispatch();
  const router = useHistory();
  const location = useLocation();
  const urlParams = queryString.parse(location.search);

  function handleFailure(error: any) {
    router.push('/login');
    trackError(errorMessage.CallbackA, error);
  }

  if (urlParams.access_code) {
    axios
      .post(
        apiEndpoints.tokenAccess,
        { access_code: urlParams.access_code },
        { headers: { 'Content-Type': 'application/json' } }
      )
      .then((response) => {
        const authData: AuthResponseData = jwtDecode(response.data.access_token);
        const organizationId = authData.org_uuid;
        const redirectToOnboarding = shouldOnboardUser(
          urlParams.user === 'new_user',
          response.data.onboardingStep
        );

        Storage.set('organizationId', organizationId); // TO-DO: Remove app-wide(x1 in integrations.ts) of orgId from storage

        saveTokens(response.data.access_token, response.data.refresh_token)
          .then(() => {
            dispatch({
              type: 'LOGIN',
              payload: {
                access_token: response.data.access_token,
                refresh_token: response.data.refresh_token,
              },
            });

            if (redirectToOnboarding) {
              router.push('/onboarding/');
            } else {
              router.push('/');
            }
          })
          .catch((error) => handleFailure(error));
      })
      .catch((error) => handleFailure(error));
  }

  return (
    <div className={styles.container}>
      <div className={styles.ldsRing}>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
};
